import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";

import { LogoMark } from "./LogoMark";
import { ColorStop } from "./types";

interface LogoProps {
  colorStops?: ColorStop[];
  borderWidth?: number;
  size?: number;
  wordmark?: boolean;
}

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const StyledLogoMark = styled(LogoMark)`
  width: ${({ size = 0, borderWidth = 0 }) => (size + borderWidth) / 16}rem;
  height: ${({ size = 0, borderWidth = 0 }) => (size + borderWidth) / 16}rem;
  margin-right: 0.5rem;

  border: ${({ borderWidth = 0 }) => borderWidth / 16}rem solid #ffffff;
  border-radius: 20%;
  background-size: 100%;
  transform: rotate(-90deg);
`;

const WordMark = () => (
  <svg
    height="25px"
    version="1.1"
    viewBox="0 0 74 25"
    width="74px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.36840512,24.7093023 L3.16621271,24.7093023 C2.80641581,24.7093023 2.51857829,24.3822674 2.51857829,24.0188953 L2.51857829,10.5014535 L0.683614109,10.5014535 C0.323817209,10.5014535 0,10.1744186 0,9.81104651 L0,7.19476744 C0,6.83139535 0.323817209,6.54069767 0.683614109,6.54069767 L2.51857829,6.54069767 L2.51857829,5.30523256 C2.51857829,1.38081395 4.38952217,0 8.38326775,0 L9.39069907,0 C9.75049597,0 10.0743132,0.290697674 10.0743132,0.654069767 L10.0743132,2.90697674 C10.0743132,3.27034884 9.75049597,3.59738372 9.39069907,3.59738372 L9.17482093,3.59738372 C7.41181612,3.59738372 7.05201922,4.36046512 7.05201922,6.10465116 L7.05201922,6.54069767 L9.35471938,6.54069767 C9.71451628,6.54069767 10.0383335,6.83139535 10.0383335,7.19476744 L10.0383335,9.81104651 C10.0383335,10.1744186 9.71451628,10.5014535 9.35471938,10.5014535 L7.05201922,10.5014535 L7.05201922,24.0188953 C7.05201922,24.3822674 6.72820202,24.7093023 6.36840512,24.7093023 Z M15.8310636,24.7093023 L12.5928915,24.7093023 C12.2330946,24.7093023 11.9452571,24.3822674 11.9452571,24.0188953 L11.9452571,0.690406977 C11.9452571,0.327034884 12.2330946,0 12.5928915,0 L15.8310636,0 C16.1908605,0 16.5146777,0.327034884 16.5146777,0.690406977 L16.5146777,24.0188953 C16.5146777,24.3822674 16.1908605,24.7093023 15.8310636,24.7093023 Z M32.7860834,18.6773256 L35.9163164,18.6773256 C36.5999305,18.6773256 36.7798289,19.0406977 36.5279711,19.622093 C35.3046617,22.8197674 31.9225708,25 27.9288252,25 C22.495892,25 18.6460652,21.1482558 18.6460652,15.6613372 C18.6460652,10.1744186 22.6398108,6.21366279 28.0007846,6.21366279 C33.3257787,6.21366279 37.2475649,10.1744186 37.2475649,15.6613372 C37.2475649,16.315407 37.0316868,16.8241279 36.420032,16.8241279 L23.3594046,16.8241279 C23.6472421,19.5130814 25.518186,20.9665698 27.9288252,20.9665698 C29.4399722,20.9665698 30.8431801,20.3851744 31.670713,19.2587209 C31.9945302,18.8226744 32.3903068,18.6773256 32.7860834,18.6773256 Z M23.3953843,13.9898256 L32.3903068,13.9898256 C31.9585505,11.627907 30.159566,10.2834302 27.9288252,10.2834302 C25.6980844,10.2834302 23.8271406,11.627907 23.3953843,13.9898256 Z M55.1720375,24.7093023 L51.3601892,24.7093023 C51.0723517,24.7093023 50.8204939,24.5276163 50.6405954,24.3459302 L46.1071545,18.75 L41.6816526,24.3459302 C41.5017542,24.5276163 41.2139166,24.7093023 40.9260791,24.7093023 L37.4020684,24.7093023 C36.862373,24.7093023 36.6824746,24.0915698 37.0422715,23.6555233 L43.4106766,15.5523256 L37.1142309,7.63081395 C36.7904137,7.19476744 36.9703121,6.54069767 37.5100075,6.54069767 L41.2498963,6.54069767 C41.5377339,6.54069767 41.753612,6.72238372 41.9694901,6.97674419 L46.3230326,12.318314 L50.6405954,6.97674419 C50.7845142,6.79505814 51.0003923,6.54069767 51.3242095,6.54069767 L54.8841999,6.54069767 C55.3879156,6.54069767 55.6397734,7.15843023 55.3159562,7.59447674 L49.0554902,15.5159884 L55.567814,23.6918605 C55.8916313,24.0915698 55.7477125,24.7093023 55.1720375,24.7093023 Z M59.8599819,15.625 C59.8599819,18.568314 62.0547429,20.8212209 64.7532197,20.8212209 C67.4516964,20.8212209 69.6464575,18.6046512 69.6464575,15.625 C69.6464575,12.6090116 67.4516964,10.4287791 64.7532197,10.4287791 C62.0547429,10.4287791 59.8599819,12.681686 59.8599819,15.625 Z M73.3163859,24.7093023 L70.2581122,24.7093023 C69.8983153,24.7093023 69.6104778,24.3822674 69.6104778,24.0188953 L69.6104778,22.4200581 C68.2792293,24.0188953 66.3723057,25 63.9976462,25 C59.1403881,25 55.2905612,20.9665698 55.2905612,15.625 C55.2905612,10.2834302 59.1763678,6.21366279 64.0696056,6.21366279 C66.3723057,6.21366279 68.2792293,7.19476744 69.6104778,8.75726744 L69.6104778,7.23110465 C69.6104778,6.86773256 69.8983153,6.54069767 70.2581122,6.54069767 L73.3163859,6.54069767 C73.6761828,6.54069767 74,6.86773256 74,7.23110465 L74,24.0188953 C74,24.3822674 73.6761828,24.7093023 73.3163859,24.7093023 Z"
      id="flexa-wordmark"
    ></path>
  </svg>

  // <ReactSVG
  //   {...props}
  //   src={wordmark}
  //   beforeInjection={(svg) => {
  //     svg.setAttribute('width', '52')
  //     svg.setAttribute('height', '18')
  //     svg.setAttribute('style', `fill: ${fill}; width: 100%`)
  //   }}
  // />
);

const Logo = ({
  colorStops = [
    { color: "#8180ff", stop: 0 },
    { color: "#0069cc", stop: 31 },
    { color: "#00cc99", stop: 50 },
    { color: "#ffffff", stop: 50 },
    { color: "#ebfaff", stop: 62 },
    { color: "#8a80ff", stop: 91 },
    { color: "#8180ff", stop: 0 },
  ],
  borderWidth = 0,
  size = 24,
  wordmark = false,
}: LogoProps) => (
  <Container>
    <StyledLogoMark
      borderWidth={borderWidth}
      colorStops={colorStops}
      size={size}
    />
    {wordmark ? (
      <WordMark
        css={css`
          width: 3.25rem;
          line-height: 0;
          margin: 0;
          padding: 0;
        `}
      />
    ) : null}
  </Container>
);

export default Logo;
